import React from 'react'
import { useAboutSiteToggleNav } from './AboutSiteNavButton.context'
import { GridItem, HideContainer, NavButton } from './AboutSiteNavButton.styles'

/**
 * The AboutSiteNavButton's component.
 */
const AboutSiteNavButton = () => {
  const toggle = useAboutSiteToggleNav()

  const handleOpen = () => toggle()

  return (
    <HideContainer>
      <GridItem xs={2} sm={1}>
        <NavButton onClick={handleOpen} />
      </GridItem>
    </HideContainer>
  )
}

export default AboutSiteNavButton
